import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";
import capitalizeFirstLetter from "helpers/cap";

// style
import "./styles.scss";

export const Breadcrumb = () => {
	return (
		<div className="breadcrumb__container">
			<ul>
				<li>
					<a href={window.location.origin}>
						<span>Home</span>
					</a>
				</li>
				<SvgRightArrow />
				<li>
					<a
						href={
							window.location.pathname.includes("homestays")
								? window.location.origin +
								  "/homestays/homestays-in-" +
								  window.location.pathname?.split("/")[2]?.split("-")[2]
								: window.location.origin +
								  "/villas/villas-in-" +
								  window.location.pathname?.split("/")[2]?.split("-")[2]
						}
					>
						{" "}
						<span>
							{window.location.pathname?.split("/")[2]?.split("-")[2] !==
							"me" ? (
								<>
									{window.location.pathname?.split("/")[2]?.split("-")[2] ? (
										<>
											Villas in{" "}
											{capitalizeFirstLetter(
												window.location.pathname
													?.split("/")[2]
													?.split("-")[2]
													?.replace("%20", " "),
											)}
										</>
									) : (
										""
									)}
								</>
							) : (
								"Villas Near Me"
							)}
						</span>
					</a>
				</li>
			</ul>
		</div>
	);
};
